class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('.newsletter-popup__close');

    if (!this.dialog || !this.closeButton || window.Shopify?.designMode || this.wasDismissed()) return;

    this.closeButton.addEventListener('click', this.closeDialog);
    this.dialog.addEventListener('click', this.handleBackdropClick);
    this.dialog.addEventListener('close', this.rememberDismissal);

    this.timer = window.setTimeout(() => {
      if (this.isConnected && !this.dialog.open) this.dialog.showModal();
    }, 3000);
  }

  disconnectedCallback() {
    window.clearTimeout(this.timer);
    this.closeButton?.removeEventListener('click', this.closeDialog);
    this.dialog?.removeEventListener('click', this.handleBackdropClick);
    this.dialog?.removeEventListener('close', this.rememberDismissal);
  }

  wasDismissed() {
    try {
      return window.sessionStorage.getItem('fontana-newsletter-popup-dismissed') === 'true';
    } catch {
      return false;
    }
  }

  closeDialog = () => this.dialog.close();

  handleBackdropClick = (event) => {
    if (event.target === this.dialog) this.dialog.close();
  };

  rememberDismissal = () => {
    try {
      window.sessionStorage.setItem('fontana-newsletter-popup-dismissed', 'true');
    } catch {
      // The dialog still works when browser storage is unavailable.
    }
  };
}

if (!customElements.get('newsletter-popup')) {
  customElements.define('newsletter-popup', NewsletterPopup);
}